import React from 'react';

export interface PatientData {
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  avatar: string | null;
  phoneNumber: string;
  gender: 'male' | 'female' | 'other';
  address: string;
  dateOfBirth: string;
  rmrKcalDay: number;
  weight: number;
}

interface PatientDataFormProps {
  patient: PatientData;
  editMode: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onEditToggle: () => void;
  onSave: (e: React.FormEvent) => void;
}

const PatientDataForm: React.FC<PatientDataFormProps> = ({ patient, editMode, onChange, onEditToggle, onSave }) => (
  <>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
      {/* Avatar - shows image if available, otherwise initials */}
      <div style={{ width: 100, height: 100, borderRadius: '50%', overflow: 'hidden', position: 'relative' }}>
        {patient.avatar ? (
          <img 
            src={patient.avatar} 
            alt={`${patient.firstName} ${patient.lastName}`}
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover',
              display: 'block'
            }}
          />
        ) : (
          <div style={{ 
            width: '100%', 
            height: '100%', 
            background: '#eee', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            fontSize: 40, 
            fontWeight: 700, 
            color: '#bbb' 
          }}>
            {patient.firstName.charAt(0)}{patient.lastName.charAt(0)}
          </div>
        )}
      </div>
      <div style={{ fontWeight: 700, fontSize: 22, color: '#222', textAlign: 'center' }}>{patient.firstName} {patient.lastName}</div>
      <button onClick={onEditToggle} style={{marginTop:8,background:'#38b2ac',color:'#fff',border:'none',borderRadius:6,padding:'6px 18px',fontWeight:600,cursor:'pointer'}}>{editMode ? 'Cancelar' : 'Editar'}</button>
    </div>
    <form style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 14 }} onSubmit={onSave}>
      <label style={{ fontWeight: 500 }}>Email
        <input name="email" value={patient.email} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Usuario
        <input name="username" value={patient.username} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Nombre
        <input name="firstName" value={patient.firstName} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Apellido
        <input name="lastName" value={patient.lastName} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Teléfono
        <input name="phoneNumber" value={patient.phoneNumber} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Género
        <select name="gender" value={patient.gender} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }}>
          <option value="male">Masculino</option>
          <option value="female">Femenino</option>
          <option value="other">Otro</option>
        </select>
      </label>
      <label style={{ fontWeight: 500 }}>Dirección
        <input name="address" value={patient.address} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Fecha de nacimiento
        <input name="dateOfBirth" type="date" value={patient.dateOfBirth} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>RMR (Kcal/día)
        <input name="rmrKcalDay" type="number" value={patient.rmrKcalDay} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      <label style={{ fontWeight: 500 }}>Peso (kg)
        <input name="weight" type="number" value={patient.weight} onChange={onChange} disabled={!editMode} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }} />
      </label>
      {editMode && <button type="submit" style={{marginTop:10,background:'#38b2ac',color:'#fff',border:'none',borderRadius:6,padding:'8px 0',fontWeight:600,cursor:'pointer'}}>Guardar</button>}
    </form>
  </>
);

export default PatientDataForm; 